import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LensIcon from '@material-ui/icons/Lens';
import OriginIcon from '@material-ui/icons/TripOrigin';

const useStyles = makeStyles(() => ({
  root: {
    color: props => props.value,
    padding: '0px'
  },
  checked: {
    color: props => `${props.value} !important`
  }
}));

const ColorRadioButton = ({ value, ...rest }) => {
  const classes = useStyles({ value });

  return (
    <Box
      component={FormControlLabel}
      value={value}
      control={
        <Radio
          classes={{
            root: classes.root,
            checked: classes.checked
          }}
          icon={<LensIcon />}
          checkedIcon={<OriginIcon />}
        />
      }
      {...rest}
    />
  );
};

ColorRadioButton.propTypes = {
  value: PropTypes.string.isRequired
};

export default ColorRadioButton;
